import React from "react";
import {
  // HiXCircle,
  // MdSkipNext,
  FaCheckCircle,
  // MdExitToApp
} from "react-icons/fa";
import { useTranslation } from "react-i18next";

export default function ZoomAnswerBottomButton(props) {
  const { t } = useTranslation();
  return (
    <>
      <button
        // disabled={props.isLoading}
        className={`button is-small modal-button ${
          props.disabled ? "button-disabled" : ""
        }`}
        onClick={props.onClickHandler}
        title={t("Show Answer")}
      >
        <span className="icon has-text-success mb-2">
          <FaCheckCircle className="fas fa-2x" />
        </span>
        <span className="has-text-light is-hidden-tablet-only  is-hidden-mobile mb-2">
          {t("Show Answer")}
        </span>
      </button>
    </>
  );
}
